import './core'

function getDuSafeJockey() {
  if (typeof window !== 'undefined') {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const duSafeJockey = require('@du/jsbridge/dist/du-jsBridge.es').default.duSafeJockey
    return duSafeJockey
  }
  throw new Error('不要在服务端使用Jockey')
}

export interface ShareOptionType {
  title: string
  description: string
  link?: string
  imgUrl?: string
  channels?: number[]
}

export type ShareResultCallbackType = () => void

class Jockeys {
  /**
   * native 分享
   * @param {Object} options
   * @property {String} options.title         分享其他平台时的标题
   * @property {String} options.description   描述
   * @property {String} options.link          分享的url地址
   * @property {String} options.imgUrl        分享的图片链接，只给 instagram 用
   */
  static socialShare(options: ShareOptionType) {
    getDuSafeJockey().send('socialShare', options)
  }

  /**
   * native 右上角分享
   * @param {Object} options
   * @property {String} options.title         分享其他平台时的标题
   * @property {String} options.description   描述
   * @property {String} options.link          分享的url地址
   * @property {String} options.imgUrl        分享的图片链接
   */
  static rightBarButtonItem(options: ShareOptionType) {
    getDuSafeJockey().send('rightBarButtonItem', options)
  }

  static setNavigationBarButtonList(options: {
    list: (Partial<ShareOptionType> & { type: number })[]
  }) {
    getDuSafeJockey().send('setNavigationBarButtonList', options)
  }

  static enableNativePush() {
    getDuSafeJockey().send('enableNativePush');
  }

  // webview focus 处理页面是否需要刷新
  static refreshHybridData(refreshHybridData) {
    getDuSafeJockey().on('refreshHybridData', (...args) => {
      refreshHybridData(...args)
    })
  }

  static setTitle(title: string) {
    document.title = title
    getDuSafeJockey().send('setTitle', { title })
  }

  // push 状态监听 notificationState 开启状态，0 关闭，1 开启
  static getNotificationState(fun) {
    getDuSafeJockey().on('getNotificationState', function ({ notificationState }) {
      fun(notificationState)
    })
  }

  static login() {
    getDuSafeJockey().send('login')
  }

  // 设置webview 右上角链接展示
  static registerBarAction({ actionName = '', routerUrl = '', iconUrl='', nativeUrl = '' }) {
    getDuSafeJockey().send('registerBarAction', {
      actionName,
      iconUrl,
      routerUrl: nativeUrl ?  `https://**.com/router${nativeUrl}` : `https://**.com/router/web/browser?url=${routerUrl}`
    })
  }

  // 处理分享成功的回调 shareStatus 0 - 成功；1 - 失败；2 - 取消；
  // 搭建器项目里因为是SPA，只有在index页面监听一次，走发布订阅
  static handleShareResult(fun) {
    getDuSafeJockey().on('handleShareResult', function ({ shareStatus, shareChannel }) {
      fun({ shareStatus, shareChannel })
    })
  }

  static closeCurrentPage(succeed = false) {
    getDuSafeJockey().send('closeCurrentPage', { succeed })
  }

  static openNativePage(url, query = {}) {
    let queryStr = Object.keys(query)
      .map((key) => `${key}=${query[key]}`)
      .join('&')
    queryStr = queryStr ? `?${queryStr}` : ''
    console.log(`https://**.com/router${url + queryStr}`)
    getDuSafeJockey().send('openNativePage', {
      routerUrl: `https://**.com/router${url + queryStr}`,
    })
  }

  static previewImages(index, images = []) {
    getDuSafeJockey().send('showContentImages', { index: Number(index), images })
  }
  // 业务数据同步
  static receiveH5Data(type: string, data: { advType: number, state: number }) {
    console.error(type, data, 'data..data..data..')
    getDuSafeJockey().send('receiveH5Data', { data, type })
  }

  static setStatusBarTransparent(data) {
    getDuSafeJockey().send('setStatusBarTransparent', {
      isTransparent: data,
    })
    // 设置状态栏是否透明 1透明，0不透明
  }

  static getPlatformInfoCallback(...args) {
    getDuSafeJockey().on('getPlatformInfoCallback', ...args)
  }

  static getPlatformInfo(...args) {
    getDuSafeJockey().send('getPlatformInfo', ...args)
  }
}

function setShare(
  { shareIcon, shareSubtitle, shareTitle, shareUrl = window.location.href }: any,
  isDangerPage: boolean
) {
  Jockey.rightBarButtonItem({
    title: shareTitle,
    description: shareSubtitle,
    link: shareUrl,
    imgUrl: shareIcon,
  })
}

export {
  setShare,
}

export default Jockeys
